import React from 'react';
import ConflictResourceGroup from './ConflictResourceGroup';
import { getInitials } from '../../../../../utils/resourceUtils';

const ConflictContent = ({
    activeTab,
    setActiveTab,
    isDetectionEnabled,
    sections,
    expandedResources,
    toggleExpand,
    collapsedSections,
    toggleSection,
    onEditAssignment,
    onEditResource,
    formatReason,
    allFlattened,
    sortConfig,
    toggleSort
}) => {

    // Helper to match the original getAvatarColor in both components
    const getAvatarColor = (name) => {
        const colors = ['#6366f1', '#8b5cf6', '#ec4899', '#f43f5e', '#f59e0b', '#10b981', '#06b6d4'];
        let hash = 0;
        for (let i = 0; i < (name?.length || 0); i++) hash = name.charCodeAt(i) + ((hash << 5) - hash);
        return colors[Math.abs(hash) % colors.length];
    };

    return (
        <div className="co-content">
            {!isDetectionEnabled ? (
                    <div className="co-empty-state">
                        <div className="co-empty-icon">🔍</div>
                        <h3>Konfliktprüfung deaktiviert</h3>
                        <p>Aktiviere die Prüfung oben rechts, um Überschneidungen zu finden.</p>
                    </div>
                ) : (
                    <>
                        {activeTab === 'resources' && sections.map(section => {
                            const isCollapsed = collapsedSections.has(section.id);
                            if (section.groups.length === 0) return null;

                            return (
                                <div key={section.id} className="co-resource-section">
                                    <div className="co-section-header" onClick={() => toggleSection(section.id)}>
                                        <div className="co-section-title-area" style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
                                            <div className="co-section-title">
                                                <span style={{ marginRight: 8 }}>{section.icon}</span>
                                                {section.title}
                                            </div>
                                            <span className="co-section-badge">{section.groups.length}</span>
                                        </div>
                                        <span className="co-section-toggle">{isCollapsed ? 'Mehr anzeigen' : 'Weniger anzeigen'}</span>
                                    </div>
                                    {!isCollapsed && (
                                        <div className="co-resource-grid">
                                            {section.groups.map(group => (
                                                <ConflictResourceGroup
                                                    key={`${group.type}-${group.id}`}
                                                    group={group}
                                                    isExpanded={expandedResources.has(`${group.type}-${group.id}`)}
                                                    onToggle={toggleExpand}
                                                    onEditAssignment={onEditAssignment}
                                                    onEditResource={onEditResource}
                                                    formatReason={formatReason}
                                                />
                                            ))}
                                        </div>
                                    )}
                                </div>
                            );
                        })}

                        {(activeTab === 'list' || activeTab === 'archive') && (
                            <div className="co-flat-list">
                                <div className="co-list-header">
                                    <div className="co-header-cell sortable" style={{ flex: 2, cursor: 'pointer' }} onClick={() => toggleSort('resource')}>
                                        Mitarbeiter / Fahrzeug {sortConfig.key === 'resource' && (sortConfig.direction === 'asc' ? '↑' : '↓')}
                                    </div>
                                    <div className="co-header-cell sortable" style={{ flex: 1, cursor: 'pointer' }} onClick={() => toggleSort('date')}>
                                        Datum {sortConfig.key === 'date' && (sortConfig.direction === 'asc' ? '↑' : '↓')}
                                    </div>
                                    <div className="co-header-cell" style={{ flex: 2 }}>Projekt(e) / Zeit</div>
                                    <div className="co-header-cell sortable" style={{ flex: 2, cursor: 'pointer' }} onClick={() => toggleSort('reason')}>
                                        Grund / Details {sortConfig.key === 'reason' && (sortConfig.direction === 'asc' ? '↑' : '↓')}
                                    </div>
                                </div>

                                <div className="co-list-rows">
                                    {(activeTab === 'list' ? allFlattened : allFlattened.filter(c => c.date < (new Date().toISOString().split('T')[0]))).map((item, idx) => (
                                        <div key={idx} className="co-conflict-row">
                                            <div className="co-col-resource" style={{ flex: 2, display: 'flex', alignItems: 'center', gap: 10 }}>
                                                <div className="co-avatar" style={{ width: 30, height: 30, fontSize: '0.75rem', background: getAvatarColor(item.resName), display: 'flex', alignItems: 'center', justifyContent: 'center', borderRadius: '8px', color: 'white', fontWeight: 700 }}>
                                                    {getInitials(item.resName)}
                                                </div>
                                                <div className="co-resource-info-compact">
                                                    <span className="co-res-name" style={{ fontWeight: 600, color: '#1e293b', fontSize: '0.85rem' }}>{item.resName}</span>
                                                    <span className="co-res-role" style={{ fontSize: '0.7rem', color: '#64748b' }}>{item.resRole}</span>
                                                </div>
                                            </div>

                                            <div className="co-col-date" style={{ flex: 1, fontSize: '0.85rem', color: '#475569' }}>
                                                {item.date?.split('-').reverse().join('.') || 'Unbekannt'}
                                            </div>

                                            <div className="co-col-projects" style={{ flex: 2, display: 'flex', flexDirection: 'column', gap: 4 }}>
                                                {item.assignments?.map((a, aIdx) => (
                                                    <div key={aIdx} className="co-mini-tile-row" onClick={() => onEditAssignment(a)} style={{ background: '#eff6ff', border: '1px solid #dbeafe', padding: '6px 10px', borderRadius: '6px', cursor: 'pointer', display: 'flex', flexDirection: 'column' }}>
                                                        <span className="co-tile-pname" style={{ fontSize: '0.75rem', fontWeight: 700, color: '#1e40af' }}>{a.projektname || a.project_name}</span>
                                                        <span className="co-tile-ptime" style={{ fontSize: '0.65rem', color: '#3b82f6' }}>
                                                            {new Date(a.start_datetime || a.start).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })} - {new Date(a.end_datetime || a.end).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}
                                                        </span>
                                                    </div>
                                                ))}
                                                {/* Redundant absence tile removed as requested */}
                                            </div>

                                            <div 
                                                className="co-col-reason" 
                                                style={{ flex: 2, cursor: item.absence ? 'pointer' : 'default' }} 
                                                onClick={() => item.absence && onEditResource && onEditResource(item.resourceId, item.resType, { action: 'absences', absenceId: item.absence.id })}
                                            >
                                                <div className="co-reason-badge" style={{ display: 'inline-block', padding: '4px 10px', background: '#fff1f2', color: '#e11d48', borderRadius: '6px', fontWeight: 700, fontSize: '0.75rem' }}>
                                                    <span>⚠️</span> {formatReason(item.reason)}
                                                </div>
                                                <div className="co-reason-desc" style={{ fontSize: '0.7rem', color: '#64748b', marginTop: 4 }}>{item.details || (item.assignments?.length > 1 ? 'Überschneidung' : 'Belegungskonflikt')}</div>
                                            </div>
                                        </div>
                                    ))}
                                    {activeTab === 'archive' && allFlattened.filter(c => c.date < (new Date().toISOString().split('T')[0])).length === 0 && (
                                        <div style={{ padding: '60px', textAlign: 'center', color: '#94a3b8' }}>Keine archivierten Konflikte</div>
                                    )}
                                </div>
                            </div>
                        )}
                    </>
                )}

                {isDetectionEnabled && activeTab === 'resources' && sections.every(s => s.groups.length === 0) && (
                    <div className="co-empty-state">
                        <div className="co-empty-icon">✨</div>
                        <h3>Keine Konflikte gefunden</h3>
                        <p>Aktuell gibt es keine Überschneidungen für die gewählten Filter.</p>
                    </div>
                )}
        </div>
    );
};

export default ConflictContent;
